import React from 'react';
import {connect} from 'react-redux';

import APPCONFIG from '../../constants/config';
import QueueAnim from 'rc-queue-anim';
import PropTypes from 'prop-types';
import {withRouter} from "react-router-dom";
import {Button} from "antd";
import './login.css';


class Login extends React.Component {

    static propTypes = {
        history: PropTypes.object.isRequired,
        loggedIn: PropTypes.bool
    };

    componentWillReceiveProps(nextProps) {
        if (nextProps.loggedIn)
            this.props.history.push(`/`)
    }

    render() {
        const returnUri = window.location.protocol + '//' + window.location.host + '/';
        return (
            <div className="body-inner">
                <div className="box box-default">
                    <div className="box-body" style={{textAlign: 'center'}}>

                        <section className="logo text-center">
                            <h1><a href="#/">Slim Opgewekt! Benchmark</a></h1>
                        </section>


                        <a href={APPCONFIG.authUri + returnUri} >
                            <Button>
                                Log in met je Office365 account
                            </Button>
                        </a>
                    </div>
                </div>
            </div>
        );
    }
}

const Page = (props) => (
    <div className="page-login">
        <div className="main-body">
            <QueueAnim type="bottom" className="ui-animate">
                <div key="1">
                    <Login {...props} />
                </div>
            </QueueAnim>
        </div>
    </div>
);

const mapStateToProps = state => {
    return {
        loggedIn: state.auth.status
    }
};

export default connect(mapStateToProps)(withRouter(Page));



// WEBPACK FOOTER //
// ./src/components/shared/login.js